import Vue from "vue";
import url from "./apiUrls";
import { store } from "../../store/store";
import { authenticationApi } from "../authenticationApi";

let Interval = "";
export const adminAuthentication = new Vue({
  methods: {
    adminLoginApi(bodyData) {
      const headerData = {
        Authorization: "Basic Y2xpZW50OnNlY3JldA==",
        "Content-Type": "application/x-www-form-urlencoded"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.adminLogin, bodyData, { headers: headerData })
          .then(res => {
            store.dispatch("adminAuth/setToken", res.data.access_token);
            store.dispatch("adminAuth/setRefreshToken", res.data.refresh_token);
            resolve(res);
          })
          .catch(e => {
            clearInterval(Interval);
            authenticationApi.logOut();
            reject(e);
          });
      });
    },
    async adminLogin(username, password) {
      const bodyData1 = {
        grant_type: "password",
        username: username,
        password: password
      };
      const bodyData = Object.keys(bodyData1)
        .map(key => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(bodyData1[key])
          );
        })
        .join("&");
      await this.adminLoginApi(bodyData);
      Interval = setInterval(() => {
        this.getAccessToken(store.state.adminAuth.refreshToken);
      }, 43000);
    },
    getAccessToken(refreshToken) {
      const bodyData1 = {
        grant_type: "refresh_token",
        refresh_token: refreshToken
      };
      const bodyData = Object.keys(bodyData1)
        .map(key => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(bodyData1[key])
          );
        })
        .join("&");
      this.adminLoginApi(bodyData);
    }
  }
});
